module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-lateral-4648244eb495e27c53bf115f991e9472.jpg";